module.exports = __webpack_public_path__ + "img/step_05.9033992b.png";